import ButtonsStep from "./buttons-step";

import image1 from '../assets/yes.svg';
import image1hover from '../assets/yes-hover.svg';
import image2 from '../assets/yes.svg';
import image2hover from '../assets/yes-hover.svg';
import image3 from '../assets/no.svg';
import image3hover from '../assets/no-hover.svg';

function Step6() {
    const stepTitle = `Do you currently use accounting software?`;

    const stepElements = [
        {
            "text": "Yes, QuickBooks",
            "image": image1,
            "imageHover": image1hover,
            "value": 1
        },
        {
            "text": "Yes, other software",
            "image": image2,
            "imageHover": image2hover,
            "value": 2
        },
        {
            "text": "No",
            "image": image3,
            "imageHover": image3hover,
            "value": 3
        },
    ];

    return (
        <>
            <h3 className='h2 fw-normal mb-5 text-center'>{stepTitle}</h3>
            <ButtonsStep stepElements={stepElements} stepTitle={stepTitle}></ButtonsStep>
        </>
    );
}

export default Step6;